export const DownloadIcon: React.FC<{ className?: string; color?: string }> = ({ className, color }) => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" className={className}>
    <path d="M10.5 7.7L9.52 6.72L7.7 8.54V0H6.3V8.54L4.48 6.72L3.5 7.7L7 11.2L10.5 7.7Z" fill={color ?? '#00466B'} />
    <path d="M12.6 8.40002V12.6H1.4V8.40002H0V14H14V8.40002H12.6Z" fill={color ?? '#00466B'} />
  </svg>
);
